import React from 'react';
import { useTranslation } from 'react-i18next';

import { REPUBS } from '@cx-modules/constants';
import { type Repub } from '@cx-modules/types';

import MiniBetslip from '~/components/betslip/components/mini-betslip';
import { useServicesContext } from '~/providers/services-context';

import styles from '../../MobileBottomNav.module.css';
import { handleEvent } from '../../utils/handleEvent';

export const BetslipToggle = ({ repub }: {repub: Repub;}) => {
  const { trackingActions } = useServicesContext();
  const { t } = useTranslation(['label']);
  const betslipText = t('CX_BETSLIP');

  return (
    <li
      className={`${styles.menuItem}`}
      onClick={() => handleEvent(betslipText, trackingActions)}>

			<span className={styles.iconContainer}>
				<MiniBetslip
          betslipTitle={betslipText}
          countryCode={REPUBS[repub].countryCode} />

			</span>
			{betslipText}
		</li>);

};